<template>
  <div v-if="showDeposit" :class="{ 'ssu-deposit': true, single: single }">
    {{ depositInfo }}
  </div>
</template>

<script>
export default {
  props: {
    ssu: {
      type: Object,
      default: () => {}
    },
    showDeposit: {
      type: Boolean,
      default: false
    },
    single: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    depositInfo() {
      const depositInfo =
        this.ssu.ssuPrice.depositInfo || this.ssu.ssuPrice.packagePriceMsg || ''

      return depositInfo
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.ssu-deposit {
  color: #666666;
  font-size: 11px;
  letter-spacing: 0;
  margin-top: 8px;
}
.single {
  margin-left: 148px;
}
</style>
